import { useState, useEffect } from "react";
const baseUrl = process.env.REACT_APP_API_BASE_URL

export function useRegulationsHome() {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const controller = new AbortController();

        async function fetchRegulations() {
            try {
                setLoading(true);
                const res = await fetch(`${baseUrl}regulation/read-published`, {
                    headers: {
                        Accept: "*/*",
                    },
                    signal: controller.signal,
                });

                if (!res.ok) {
                    throw new Error(`HTTP error! status: ${res.status}`);
                }

                const result = await res.json();
                setData(result);
            } catch (err) {
                if (err.name !== "AbortError") {
                    setError(err.message);
                }
            } finally {
                setLoading(false);
            }
        }

        fetchRegulations();

        return () => controller.abort();
    }, []);

    return { data, loading, error };
}
